<template>
  <div class="componentsNav">
      <!-- banner -->
      <div class="banner">
          <img class="bannerText" :src="bannerTextIMG" alt="">
          <img class="bannerimg" :src="bannerimgIMG" alt="">
      </div>
      <!-- content  -->
      <div class="contentNav">
          <div class="Navcontaniner">
          <div class="back" @click="$router.back(-1)"><i class="el-icon-back"></i> 返回</div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item  v-for="(x,i) in this.$store.state.Currentposition" :key="i" :to="{ path: x.path }">{{x.name}}</el-breadcrumb-item>
          </el-breadcrumb>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name:'contentNav',
  props: {
    bannerTextIMG:String,
    bannerimgIMG:String,
  },
  data(){
    return{
    }
  },
  methods:{
  },
  created(){ }
}
</script>

<style lang="scss" scoped>
  .banner{
      display: block;
      position: relative;
      width: 100%;
      height: 448px;
      overflow: hidden;
      @media screen and (max-width:768px) {
        height: 140px;
      }
      .bannerimg{
        position: absolute;
        left: 0;
        top: 0px;
        z-index: -9;
        width: 100%;
        height: 100%;
        object-fit: cover;
        @media screen and (max-width:768px) {
          height: 100%;
          width: 100%;
        }
      }
      .bannerText{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 999;
        @media screen and (max-width:768px) {
          height: 20px;
        }
      }
    }
    .contentNav{
      position: relative;
      width: 100%;
      height: 50px;
      background-color: #f0f0f0;
      line-height: 50px;
        @media screen and(max-width:768px) {
          height: 33px;
        }
      .Navcontaniner{
        position: relative;
        display: flex;
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        align-items: center;
        @media screen and(max-width:768px) {
            width: 100%;
            padding: 0 33px;
            font-size: 14px!important;
          }
        .back{
          width: 80px;
          height: 35px;
          background-color: #d0a971;
          text-align: center;
          color: #fff;
          line-height: 35px;
          margin-right: 20px;
          cursor: pointer;
          @media screen and(max-width:768px) {
            display: none;
          }
        }
      }
    }
</style>